import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraTelefone,aplicarMascaraCEP} from "../../lib/formatarCampos";
const initialBalancosEnergeticoState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  entitiesContratos:null,
  selectedContratosId:null,
  entitiesPorUC:null,
  totalCountPorUC: 0,
  balancoEnergeticoForEdit: undefined,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const balancoEnergeticoSlice = createSlice({
  name: "balancoEnergetico",
  initialState: initialBalancosEnergeticoState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBalancoEnergeticoById
    balancoEnergeticoFetched: (state, action) => {


      state.actionsLoading = false;
      // APLICAR A MASCARA
      state.balancoEnergeticoForEdit = action.payload.balancoEnergeticoForEdit;
      state.entitiesContratos = action.payload.balancoEnergeticoForEdit;
      if(action.payload.balancoEnergeticoForEdit && action.payload.balancoEnergeticoForEdit.length>0)
      {
        state.selectedContratosId=action.payload.balancoEnergeticoForEdit[0].id;
      }
      //
      state.entitiesPorUC=null;
      state.totalCount = action.payload.balancoEnergeticoForEdit.length;
      state.error = null;

    },
    // findBalancosEnergetico
    balancosEnergeticoFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;

    },
    balancosEnergeticoFetchedPorUC: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entitiesPorUC = entities;
      state.totalCountPorUC = totalCount;

    },
    // createBalancoEnergetico
    balancoEnergeticoCreated: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      // state.entities.push(action.payload.balancoEnergetico);
    },
    // updateBalancoEnergetico
    balancoEnergeticoUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.balancoEnergetico.id) {
          return action.payload.balancoEnergetico;
        }
        return entity;
      });
    },

    // balancosEnergeticoUpdateState
    balancosEnergeticoStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
